import Vue from "vue";
import Vuex from "vuex";
import { apiHost } from "./config";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    currentUser: {},
    apiHost: apiHost,
    loadingInfo: {
      show: false,
      text: "Cargando información...",
    },
    loadingDelete: {
      show: false,
      text: "Eliminando elemento...",
    },
    realizarCorteCaja: false,
    notificacionCorteCaja: false,
    operationInProgress: false, //Utilizado en el guardado
    operationFailed: false,
    operationSuccess: false,
    snackbar: {
      y: "top",
      x: "right",
      mode: "vertical",
      timeout: 6000,
      visible: false,
      color: "",
      text: "",
    },
    tituloForm: "",
    iconoForm: "",
    openDialog: false,
    errorMessage: "",
    successMessage: "",
    version: "Extrayendo...",
  },
  mutations: {},
  actions: {},
});
